module.exports = __webpack_public_path__ + "static/img/wanted2.c0d62f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/wanted2.png
// module id = eKCb
// module chunks = 1 3